import { memo, useState } from 'react';

const Accordian = memo((props) => {
  const [show, setShow] = useState(props.show);

  return (
    <>
      <div className='font-16 black bold my-5 pointer' onClick={() => setShow(!show)}>
        {props.title}
        <span className='float-right'>{show ? <img alt='awign_up_arrow' src='/images/up_arrow.svg' /> : <img alt='awign_down_arrow' src='/images/down_arrow.svg' />}</span>
      </div>
      {show ? <div className='gray font-14'>{props.children}</div> : null}
    </>
  );
});

Accordian.displayName = 'Accordian';

Accordian.defaultProps = {
  show: false
};

export default Accordian;
